import { magicLinkClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

/**
 * The instance's in-process auth server is mounted at `/api/auth`, so the
 * client stays same-origin (no `baseURL`) and only pins the base path. The
 * magic-link plugin backs the emailed sign-in links (both the login-page
 * "email me a link" affordance and the link an admin-created user receives).
 * There is no admin plugin: better-auth's admin endpoints authorize off its
 * own role column, which carries no authority here, so the instance refuses
 * them and user administration is the `/api/users` product API.
 */
export const authClient = createAuthClient({
  basePath: "/api/auth",
  plugins: [magicLinkClient()],
});
